import Box from "@mui/material/Box";
import IconBreadcrumbs from "../custom-breadcrumb";
import { Divider, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { Container } from "react-bootstrap";
import marketMap from '../../assets/market.jpg'
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { ItemsImages } from "../../utils/items-list";
import config from "../../config.json";

export const MarketPlacePage = () => {

    const apiEndPoint = config.apiEndPoint + 'info/marketplace';
    const [result, setResult] = useState([]);
    const [enabled, setEnabled] = useState(false);
    const [posXMg, setPosXMg] = useState(0);
    const [posYMg, setPosYMg] = useState(0);
    const imgRef = useRef();

    useEffect(() => {
        axios.get(apiEndPoint)
            .then((response) => response.data)
            .then(data => {
                setResult(data);
            });
    }, []);

    const renderFilterOptions = () => {
        return (<></>);
    };

    const rotatePosition = (x, y) => {
        const newX = (x - y) * 32 + 8192 / 2;
        const newY = ((x + y) * 1) + (8192 / 10);
        return [newX, newY];
    }

    const mapWidth = 512;
    const mapHeight = 512;

    const hoverItem = (item) => {
        setEnabled(true);
        let posX = parseInt(item.positionX);
        let posY = parseInt(item.positionY);

        const newX = (posX - posY) * 32 + 8192 / 2 / 1;
        const newY = (posX + posY - (384 - 1)) * (32 / 2) + 8192 / 2;

        posX = newX * 0.0625;
        posY = newY * 0.0625;

        var elemWidth = imgRef.current.width;
        var elemHeight = imgRef.current.height;

        var scaleWidth = elemWidth / mapWidth;
        var scaleHeight = elemHeight / mapHeight;

        posX *= scaleWidth;
        posY *= scaleHeight;

        posX -= 12.5;
        posY -= 12.5;

        setPosXMg(posX);
        setPosYMg(posY);
    };

    const renderItems = () => {
        return (
            <Box style={{
                maxHeight: '50vh',
                overflowY: 'auto',
                fontFamily: "'Roboto', sans-serif",
                fontSize: "16px",
            }}>
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                            <TableRow className={"header fw-bold"} style={{ backgroundColor: '#333' }}>
                                <TableCell className="fw-bold" style={{ color: 'white', fontSize: '18px', fontFamily: 'Roboto' }}>Name</TableCell>
                                <TableCell className="fw-bold" style={{ color: 'white', fontSize: '18px', fontFamily: 'Roboto' }}>Quality</TableCell>
                                <TableCell className="fw-bold" style={{ color: 'white', fontSize: '18px', fontFamily: 'Roboto' }}>Plus</TableCell>
                                <TableCell className="fw-bold" style={{ color: 'white', fontSize: '18px', fontFamily: 'Roboto' }}>Gem1</TableCell>
                                <TableCell className="fw-bold" style={{ color: 'white', fontSize: '18px', fontFamily: 'Roboto' }}>Gem2</TableCell>
                                <TableCell className="fw-bold" style={{ color: 'white', fontSize: '18px', fontFamily: 'Roboto' }}>Seller</TableCell>
                                <TableCell className="fw-bold" style={{ color: 'white', fontSize: '18px', fontFamily: 'Roboto' }}>Price</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {result?.map((item) => (
                                <TableRow
                                    key={item.name}
                                    sx={{
                                        '&:last-child td, &:last-child th': { border: 0 },
                                        '&:hover': { backgroundColor: '#f1f1f1', cursor: 'pointer' },
                                    }}
                                    onMouseEnter={() => hoverItem(item)}
                                    onMouseLeave={() => setEnabled(false)}
                                >
                                    <TableCell style={{ padding: '16px', fontSize: '16px' }}>
                                        <img style={{
                                            width: 32,
                                            height: 32,
                                            maxWidth: 32,
                                            maxHeight: 32,
                                        }}
                                            className="me-1"
                                            src={`/items/${ItemsImages.get(item.itemId?.toString()) ?? ItemsImages.get('Default')}`} />{item?.itemName}
                                    </TableCell>
                                    <TableCell style={{ padding: '16px' }}>{item?.quality || 'Fixed'}</TableCell>
                                    <TableCell style={{ padding: '16px' }}>{item?.plus}</TableCell>
                                    <TableCell style={{ padding: '16px' }}>{item?.gem1}</TableCell>
                                    <TableCell style={{ padding: '16px' }}>{item?.gem2}</TableCell>
                                    <TableCell style={{ padding: '16px' }}>{item?.seller}</TableCell>
                                    <TableCell style={{ padding: '16px' }}>{item?.price.toLocaleString()}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        );
    };

    const renderMap = () => {
        return (
            <Box style={{
                position: 'relative',
                marginTop: '20px',
            }}>
                {enabled && <div style={{
                    position: 'absolute',
                    marginTop: posYMg,
                    marginLeft: posXMg,
                    zIndex: 1,
                }}>
                    <div className="ring-container">
                        <div className="ringring"></div>
                        <div className="circle"></div>
                    </div>
                </div>}
                <img ref={imgRef} src={marketMap} className="img-fluid" style={{ borderRadius: '10px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }} />
            </Box>
        );
    };

    return (
        <Box>
            <IconBreadcrumbs name="Marketplace" />
            <Container style={{
                maxWidth: '90%',
                fontFamily: 'Roboto, sans-serif',
                backgroundColor: '#f4f4f4',
                paddingTop: '20px',
                borderRadius: '10px',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            }}>
                <Grid container spacing={4}>
                    <Grid item md={8}>
                        <h4 className="text-uppercase" style={{
                            fontSize: '24px',
                            fontWeight: '700',
                            color: '#333',
                        }}>Items</h4>
                        <Divider />
                        {renderItems()}
                    </Grid>
                    <Grid item md={4}>
                        <h4 className="text-uppercase" style={{
                            fontSize: '24px',
                            fontWeight: '700',
                            color: '#333',
                        }}>Map</h4>
                        <Divider />
                        <Box>
                            {renderMap()}
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};
